<template>
  <div class="modal fade" id="exitpop" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" :class="size">
      <div class="modal-content" :class="modal.backgroundColor ? 'dark-modal' : ''">
        <div class="modal-header">
          <h5 class="modal-title fs-3 fw-bold">{{ modal.popupHeader }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body" v-html="modal.popupBody"></div>
        <div class="modal-footer">
          <div class="m-0 p-1" :class="!modal.buttonLink ? 'col-12' : 'col-6'">
            <button type="button" class="btn w-100 fs-5" :class="dismissColor" data-bs-dismiss="modal">{{ modal.dismissText }}</button>
          </div>
          <div class="col-6 m-0 p-1">
            <a type="button" class="btn w-100 fs-5" :class="color" :href="link()" v-if="modal.buttonLink">{{ modal.buttonText }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ouibounce from 'ouibounce';
export default {
  name: "ExitPop",
  props: ['modal'],
  data: () => ({
    slug: '',
    color: '',
    dismissColor: '',
    size: ''
  }),
  methods: {
    link(){
      $('#exitpop').modal('hide');
      var page;
      switch (this.modal.buttonLink.sys.contentType.sys.id) {
        case 'vsl':
          page = 'vsl'
          break;
        case 'orderForms':
          page = 'order'
          break;
        case 'transcript':
          page = 'transcript'
          break;
        case 'signup':
          page = 'signup'
          break;
        case 'nextStep':
          page = 'offer'
          break;
        case 'advertorials':
          page = 'artc'
          break;
      }
      return window.location.protocol + '//' + window.location.host + '/' + page + '/' + this.slug
      
    },
    leavePage(slug) {
      $('#exitpop').modal('hide');
      switch (this.modal.buttonLink.sys.contentType.sys.id) {
        case 'vsl':
          this.$router.push('/vsl/' + slug + window.location.search);
          break;
        case 'orderForms':
          this.$router.push('/order/' + slug + window.location.search);
          break;
        case 'transcript':
          this.$router.push('/transcript/' + slug + window.location.search);
          break;
        case 'signup':
          this.$router.push('/signup/' + slug + window.location.search);
          break;
        case 'nextStep':
          this.$router.push('/offer/' + slug + window.location.search);
          break;
        case 'advertorials':
          this.$router.push('/artc/' + slug + window.location.search);
          break;
      }
    },
  },
  mounted() {
    if (this.modal.buttonLink) {
      this.slug = this.modal.buttonLink.fields.slug;
    }
    if (this.modal.popupSize) {
      switch (this.modal.popupSize) {
        case 'large':
          this.size = 'modal-lg'
          break;
        case 'small':
          this.size = 'modal-sm'
          break;
      }
    }
    if (this.modal.buttonColor) {
      this.color = "btn-" + this.modal.buttonColor.name.toLowerCase();
    }
    if (this.modal.dismissButtonColor) {
      this.dismissColor = "btn-" + this.modal.dismissButtonColor.name.toLowerCase();
    }

    let oui = ouibounce(false, {
      aggressive: true,
      timer: 0,
      delay: this.modal.popupDelay ? this.modal.popupDelay : 500,
      callback: function () { $('#exitpop').modal('show'); }
    })
  },
}
</script>
<style lang="scss">
.dark-modal {
  .modal-title {
    color:white;
  }
  .modal-footer {
    background-color: #111;
  }
  border: 1px solid #333;
  background-color:#111;
  color: rgb(226, 226, 226);
}
</style>
